import React from "react";
import ReactPaginate from "react-paginate";
import "./pagination.css";

import Translate from "helpers/Translate";

export default function Pagination(props) {
  return (
    <div className="pagination">
      <div className="pagination-wrapper mt-20">
        <ReactPaginate
          pageCount={props.data && props.data.total_pages}
          pageRangeDisplayed={props.data && props.data.page_range}
          marginPagesDisplayed={props.data && props.data.page_range}
          forcePage={props.data && parseInt(props.data.current_page) - 1}
          previousLabel="&#171;"
          nextLabel="&#187;"
          breakLabel={"..."}
          onPageChange={props.onPageChange}
          containerClassName={"pagination-container"}
          activeClassName={"active"}
        />
      </div>
      <p className="pagination--total-records mt-10">
        {Translate({
          id: "total_records",
          values: [props.data.total_records]
        })}
      </p>
    </div>
  );
}
